import { BranchesService, ChannelsService, ServicesService, ZohosService } from '@/backend/market'
import { ZohoValueRepository } from '../../domain/repositories/ZohoValueRepository'
import { ZohoValueModel } from '../models/ZohoValueModel'
import type { ZohoValueEntity } from '../../domain/entities/ZohoValueEntity'

export class ZohoValueRepositoryImpl implements ZohoValueRepository {
  async getBranchZohoValues(id: number): Promise<ZohoValueModel | { error: true }> {
    try {
      const response = await BranchesService.getBranchGenericZohoValuesAdmin({
        id
      })
      const zohoModel = new ZohoValueModel(response)

      return zohoModel
    } catch {
      return { error: true }
    }
  }
  async updateBranchZohoValues(
    id: number,
    zohoValuesData: ZohoValueEntity
  ): Promise<{ success: true } | { error: true }> {
    const zohoValuesDataModel = new ZohoValueModel(zohoValuesData)
    try {
      await BranchesService.putBranchGenericZohoValuesAdmin({
        id,
        requestBody: zohoValuesDataModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async getServiceZohoValues(id: number): Promise<ZohoValueModel | { error: true }> {
    try {
      const response = await ServicesService.getServiceGenericZohoValuesAdmin({
        id
      })
      const zohoModel = new ZohoValueModel(response)

      return zohoModel
    } catch {
      return { error: true }
    }
  }
  async updateServiceZohoValues(
    id: number,
    zohoValuesData: ZohoValueEntity
  ): Promise<{ success: true } | { error: true }> {
    const zohoValuesDataModel = new ZohoValueModel(zohoValuesData)
    try {
      await ServicesService.putServiceGenericZohoValuesAdmin({
        id,
        requestBody: zohoValuesDataModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async getChannelServiceZohoAccounts(
    id: number
  ): Promise<{ id?: number; serviceId?: number; serviceName?: string | null }[] | { error: true }> {
    try {
      const response = await ChannelsService.getChannelServiceGenericZohoValueServicesAdmin({
        channelId: id
      })
      return response.accounts ?? []
    } catch {
      return { error: true }
    }
  }

  async getChannelZohoValues(
    channelId: number,
    serviceId: number
  ): Promise<ZohoValueModel | { error: true }> {
    try {
      const response = await ChannelsService.getChannelServiceGenericZohoValuesAdmin({
        channelId,
        serviceId
      })
      const zohoModel = new ZohoValueModel(response)

      return zohoModel
    } catch {
      return { error: true }
    }
  }
  async createChannelServiceZohoAccount(
    id: number,
    zohoValuesData: ZohoValueEntity,
    serviceId: number
  ): Promise<{ success: true } | { error: true }> {
    try {
      const zohoValuesDataModel = new ZohoValueModel(zohoValuesData)
      await ChannelsService.postPutChannelServiceGenericZohoValuesAdmin({
        channelId: id,
        serviceId,
        requestBody: zohoValuesDataModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async addInvoiceByDate(
    fromDate: string,
    toDate: string
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postInvoiceByDateAdmin({
        fromDate,
        toDate
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postInvoice(orderIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postInvoiceAdmin({
        requestBody: {
          orderIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteInvoice(orderIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.deleteInvoiceAdmin({
        requestBody: {
          orderIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async addPaymentByDate(
    fromDate: string,
    toDate: string
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPaymentsByDateAdmin({
        fromDate,
        toDate
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postPayment(orderIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPaymentsAdmin({
        requestBody: {
          orderIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deletePayment(orderIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.deletePaymentsAdmin({
        requestBody: {
          orderIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async addApplyPaymentByDate(
    fromDate: string,
    toDate: string
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPaymentsApplyByDateAdmin({
        fromDate,
        toDate
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postApplyPayment(orderIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPaymentsApplyAdmin({
        requestBody: {
          orderIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postPackageInvoice(packageIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPackageInvoicesAdmin({
        requestBody: {
          packageIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deletePackageInvoice(packageIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.deletePackageInvoicesAdmin({
        requestBody: {
          packageIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postPackagePayment(packageIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postPackagePaymentsAdmin({
        requestBody: {
          packageIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deletePackagePayment(packageIds: string[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.deletePackagePaymentsAdmin({
        requestBody: {
          packageIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async postApplyPackagePayment(
    packageIds: string[]
  ): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postApplyPackagePaymentsAdmin({
        requestBody: {
          packageIds
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateBranchZoho(branchId: number): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.putBranchAdmin({
        branchId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async createBranchZoho(branchId: number): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postBranchAdmin({
        branchId
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateItemZoho(itemIds: number[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.putItemsOnZohoAsyncAdmin({
        requestBody: {
          itemIds
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async submitItemToZoho(itemIds: number[]): Promise<{ success: true } | { error: true }> {
    try {
      await ZohosService.postSubmitToZohoAdmin({
        requestBody: {
          itemIds
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
